import { render, staticRenderFns } from "./CourseBuilderVideoCaptureForm.vue?vue&type=template&id=136b7048&scoped=true&"
import script from "./CourseBuilderVideoCaptureForm.vue?vue&type=script&lang=js&"
export * from "./CourseBuilderVideoCaptureForm.vue?vue&type=script&lang=js&"
import style0 from "./CourseBuilderVideoCaptureForm.vue?vue&type=style&index=0&id=136b7048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136b7048",
  null
  
)

export default component.exports